import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/Login.jsx";
import SignUpPage from "./pages/sigup.jsx";
import SelectPackages from "./pages/selectPackages.jsx";
import MainLayout from "./layout/MainLayout.jsx";
import PackageManagement from "./pages/superadmin/PackageManagement.jsx";
import AccessRights from "./pages/superadmin/AccessRights.jsx";

function App() {
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  return (
      <>
      <Routes>
        {/* ✅ Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/select-packages" element={<SelectPackages />} />
      </Routes>
        <MainLayout>
           <Routes>
        <Route path='/package-management' element={ <PackageManagement />} />
        <Route path='/access-rights' element={ <AccessRights />} />
        </Routes>
        </MainLayout>
       </>
      
  );
}

export default App;
